import { Check, type LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

// A stable component identity preserves focus and pending clicks during input updates.
export default function HealthStatCard({ icon: Icon, iconBg, iconColor, title, hasValue, children, lastText }: {
  icon: LucideIcon;
  iconBg: string;
  iconColor: string;
  title: string;
  hasValue: boolean;
  children: ReactNode;
  lastText: string;
}) {
  return <div className={`relative p-3 rounded-2xl border-2 transition-all ${hasValue ? 'bg-card border-primary/30' : 'bg-card/50 border-border/40'}`}>
    {hasValue && <div className="absolute top-2 right-2 w-5 h-5 rounded-full bg-primary flex items-center justify-center">
      <Check className="w-3 h-3 text-white" />
    </div>}
    <div className="flex items-center gap-1.5 mb-2">
      <div className={`w-6 h-6 rounded-full flex items-center justify-center ${iconBg}`}>
        <Icon className={`w-3.5 h-3.5 ${iconColor}`} />
      </div>
      <span className="text-[11px] font-semibold text-foreground">{title}</span>
    </div>
    <div className="flex justify-center mb-1">{children}</div>
    <p className="text-[9px] text-muted-foreground text-center">{lastText}</p>
  </div>;
}
